module.exports = __webpack_public_path__ + "141d4a85/img/menu-icon.5f8facae.svg";